import i18nConfig from "~/config/i18n.json"
import { objectValues } from "~/utils/object-values"

export function getAllDimensions() {
  return objectValues(i18nConfig).map((data) => data.dimension)
}
